import { css as u, LitElement as f, html as s, nothing as l } from "lit";
import { query as v, property as o, customElement as w } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
import { b as y } from "./styles-scZ6dVz-.js";
import { b as n, a as m } from "./events-CkEPl0SM.js";
import { t as g, a as x } from "./a11y-DxQW21Jt.js";
var E = Object.defineProperty, C = Object.getOwnPropertyDescriptor, t = (e, i, p, d) => {
  for (var a = d > 1 ? void 0 : d ? C(i, p) : i, h = e.length - 1, c; h >= 0; h--)
    (c = e[h]) && (a = (d ? c(i, p, a) : c(a)) || a);
  return d && a && E(i, p, a), a;
};
let r = class extends f {
  constructor() {
    super(...arguments), this.open = !1, this.position = "right", this.size = "md", this.showClose = !0, this.modal = !0, this.closeOnOverlay = !0, this.closeOnEscape = !0, this.handleKeydown = (e) => {
      e.key === "Escape" && this.closeOnEscape && (e.preventDefault(), this.hide());
    };
  }
  /** Open the drawer */
  show() {
    this.open = !0;
  }
  /** Close the drawer */
  hide() {
    this.open = !1;
  }
  handleOpen() {
    this.previousActiveElement = document.activeElement, this.modal && (document.body.style.overflow = "hidden"), this.updateComplete.then(() => {
      if (this.drawerElement) {
        this.cleanupFocusTrap = g(this.drawerElement);
        const e = x(this.drawerElement);
        e.length > 0 ? e[0].focus() : this.drawerElement.focus();
      }
    }), this.closeOnEscape && document.addEventListener("keydown", this.handleKeydown), n(this, m.OPEN), n(this, "open");
  }
  handleClose() {
    document.body.style.overflow = "", this.cleanupFocusTrap?.(), this.cleanupFocusTrap = void 0, this.previousActiveElement?.focus(), this.previousActiveElement = void 0, document.removeEventListener("keydown", this.handleKeydown), n(this, m.CLOSE), n(this, "close");
  }
  handleOverlayClick(e) {
    e.target === this.overlayElement && this.closeOnOverlay && this.modal && this.hide();
  }
  handleCloseClick() {
    this.hide();
  }
  updated(e) {
    e.has("open") && (this.open ? this.handleOpen() : e.get("open") === !0 && this.handleClose());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.cleanupFocusTrap?.(), document.removeEventListener("keydown", this.handleKeydown), document.body.style.overflow = "";
  }
  render() {
    const e = {
      overlay: !0,
      open: this.open,
      [this.position]: !0,
      [this.size]: !0,
      "no-overlay": !this.modal
    }, i = s`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `;
    return s`
      <div
        part="overlay"
        class=${b(e)}
        @click=${this.handleOverlayClick}
        aria-hidden=${!this.open}
      >
        <div
          part="drawer"
          class="drawer"
          role="dialog"
          aria-modal=${this.modal ? "true" : "false"}
          aria-labelledby=${this.drawerTitle ? "drawer-title" : l}
          aria-describedby=${this.description ? "drawer-description" : l}
          tabindex="-1"
        >
          ${this.drawerTitle || this.showClose ? s`
                <header part="header" class="header">
                  <div class="header-content">
                    <slot name="header">
                      ${this.drawerTitle ? s`<h2 part="title" id="drawer-title" class="title">${this.drawerTitle}</h2>` : l}
                      ${this.description ? s`<p part="description" id="drawer-description" class="description">${this.description}</p>` : l}
                    </slot>
                  </div>
                  ${this.showClose ? s`
                        <button
                          part="close"
                          class="close"
                          type="button"
                          aria-label="Close drawer"
                          @click=${this.handleCloseClick}
                        >
                          ${i}
                        </button>
                      ` : l}
                </header>
              ` : l}

          <div part="content" class="content">
            <slot></slot>
          </div>

          <footer part="footer" class="footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    `;
  }
};
r.styles = [
  y,
  u`
      :host {
        display: contents;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .overlay {
        position: fixed;
        inset: 0;
        z-index: var(--r5-z-overlay);
        background-color: var(--r5-bg-overlay);
        opacity: 0;
        visibility: hidden;
        transition: opacity var(--r5-duration-normal) var(--r5-ease-default),
                    visibility var(--r5-duration-normal) var(--r5-ease-default);
      }

      .overlay.open {
        opacity: 1;
        visibility: visible;
      }

      .overlay.no-overlay {
        background-color: transparent;
        pointer-events: none;
      }

      .overlay.no-overlay .drawer {
        pointer-events: auto;
      }

      .drawer {
        position: fixed;
        z-index: var(--r5-z-modal);
        display: flex;
        flex-direction: column;
        background-color: var(--r5-surface);
        border: 1px solid var(--r5-border);
        box-shadow: var(--r5-shadow-xl);
        color: var(--r5-text);
        font-family: var(--r5-font-body);
        transition: transform var(--r5-duration-normal) var(--r5-ease-out);
      }

      /* Position: Left */
      .left .drawer {
        top: 0;
        left: 0;
        bottom: 0;
        border-left: none;
        border-top-right-radius: var(--r5-radius-xl);
        border-bottom-right-radius: var(--r5-radius-xl);
        transform: translateX(-100%);
      }

      .left.open .drawer {
        transform: translateX(0);
      }

      /* Position: Right */
      .right .drawer {
        top: 0;
        right: 0;
        bottom: 0;
        border-right: none;
        border-top-left-radius: var(--r5-radius-xl);
        border-bottom-left-radius: var(--r5-radius-xl);
        transform: translateX(100%);
      }

      .right.open .drawer {
        transform: translateX(0);
      }

      /* Position: Top */
      .top .drawer {
        top: 0;
        left: 0;
        right: 0;
        border-top: none;
        border-bottom-left-radius: var(--r5-radius-xl);
        border-bottom-right-radius: var(--r5-radius-xl);
        transform: translateY(-100%);
      }

      .top.open .drawer {
        transform: translateY(0);
      }

      /* Position: Bottom */
      .bottom .drawer {
        bottom: 0;
        left: 0;
        right: 0;
        border-bottom: none;
        border-top-left-radius: var(--r5-radius-xl);
        border-top-right-radius: var(--r5-radius-xl);
        transform: translateY(100%);
      }

      .bottom.open .drawer {
        transform: translateY(0);
      }

      /* Sizes for left/right position */
      .left .drawer,
      .right .drawer {
        width: var(--drawer-width);
        max-width: calc(100vw - var(--r5-space-8));
      }

      .left.sm .drawer,
      .right.sm .drawer {
        --drawer-width: 20rem; /* 320px */
      }

      .left.md .drawer,
      .right.md .drawer {
        --drawer-width: 28rem; /* 448px */
      }

      .left.lg .drawer,
      .right.lg .drawer {
        --drawer-width: 36rem; /* 576px */
      }

      .left.xl .drawer,
      .right.xl .drawer {
        --drawer-width: 48rem; /* 768px */
      }

      .left.full .drawer,
      .right.full .drawer {
        --drawer-width: 100%;
        max-width: 100%;
        border-radius: 0;
      }

      /* Sizes for top/bottom position */
      .top .drawer,
      .bottom .drawer {
        height: var(--drawer-height);
        max-height: calc(100vh - var(--r5-space-8));
      }

      .top.sm .drawer,
      .bottom.sm .drawer {
        --drawer-height: 25vh;
      }

      .top.md .drawer,
      .bottom.md .drawer {
        --drawer-height: 40vh;
      }

      .top.lg .drawer,
      .bottom.lg .drawer {
        --drawer-height: 60vh;
      }

      .top.xl .drawer,
      .bottom.xl .drawer {
        --drawer-height: 80vh;
      }

      .top.full .drawer,
      .bottom.full .drawer {
        --drawer-height: 100%;
        max-height: 100%;
        border-radius: 0;
      }

      /* Header */
      .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--r5-space-4);
        padding: var(--r5-space-5);
        border-bottom: 1px solid var(--r5-border);
        flex-shrink: 0;
      }

      .header-content {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-lg);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
        line-height: var(--r5-leading-tight);
      }

      .description {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        margin: var(--r5-space-1) 0 0 0;
      }

      /* Close button */
      .close {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        margin: -0.25rem -0.25rem 0 0;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-md);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .close:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .close:focus-visible {
        outline: var(--r5-focus-ring-width) solid var(--r5-focus-ring-color);
        outline-offset: var(--r5-focus-ring-offset);
      }

      .close svg {
        width: 1.25rem;
        height: 1.25rem;
      }

      /* Content */
      .content {
        flex: 1;
        overflow-y: auto;
        padding: var(--r5-space-5);
      }

      /* Footer */
      .footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: var(--r5-space-2);
        padding: var(--r5-space-5);
        border-top: 1px solid var(--r5-border);
        flex-shrink: 0;
      }

      .footer:empty {
        display: none;
      }

      /* Reduced motion */
      @media (prefers-reduced-motion: reduce) {
        .overlay,
        .drawer {
          transition: none;
        }
      }
    `
];
t([
  v(".drawer")
], r.prototype, "drawerElement", 2);
t([
  v(".overlay")
], r.prototype, "overlayElement", 2);
t([
  o({ type: Boolean, reflect: !0 })
], r.prototype, "open", 2);
t([
  o({ type: String, attribute: "drawer-title" })
], r.prototype, "drawerTitle", 2);
t([
  o({ type: String })
], r.prototype, "description", 2);
t([
  o({ type: String, reflect: !0 })
], r.prototype, "position", 2);
t([
  o({ type: String, reflect: !0 })
], r.prototype, "size", 2);
t([
  o({ type: Boolean, attribute: "show-close" })
], r.prototype, "showClose", 2);
t([
  o({ type: Boolean })
], r.prototype, "modal", 2);
t([
  o({ type: Boolean, attribute: "close-on-overlay" })
], r.prototype, "closeOnOverlay", 2);
t([
  o({ type: Boolean, attribute: "close-on-escape" })
], r.prototype, "closeOnEscape", 2);
r = t([
  w("ark-drawer")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-drawer-CS2Ma2M9.js.map
